import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceResult } from '../interfaces/service-result';
import { RuntimeConfigService } from './runtime-config.service';

export abstract class BaseCrudService<CREATE, UPDATE> {

  protected http = inject(HttpClient);
  protected runtimeConfig = inject(RuntimeConfigService);

  protected constructor() {}

  /**
   * Anlegen eines neuen Datensatzes
   * @param routeEndpoint Endpunkt für den Post-Request (z.b. '/users')
   * @param body der Datenbody vom entsprechenden generischen Typ, z.B. UserCreateDto
   */
  create(routeEndpoint: string, body: CREATE): Observable<ServiceResult> {
    if (!routeEndpoint.startsWith('/')) { routeEndpoint = '/' + routeEndpoint; }
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.post<ServiceResult>(this.runtimeConfig.dataBackend + routeEndpoint, body, { headers: headers });
  }

  /**
   * Abruf aller Datensätze (Eager)
   * oder eines spezifischen Datensatzes, dessen id im ZBV-JWT claim enthalten ist
   * @param routeEndpoint Endpunkt für den GET-Request (z.b. '/users')
   */
  findAll(routeEndpoint: string): Observable<ServiceResult> {
    if (!routeEndpoint.startsWith('/')) { routeEndpoint = '/' + routeEndpoint; }
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.get<ServiceResult>(this.runtimeConfig.dataBackend + routeEndpoint, { headers: headers });
  }

  /**
   * Abruf eines spezifischen Datensatzes über die id als Routenparameter
   * @param routeEndpoint Endpunkt für den GET-Request (z.b. '/users')
   * @param id id (UUID) des Datensatzes
   */
  findById(routeEndpoint: string, id: string): Observable<ServiceResult> {
    if (!routeEndpoint.startsWith('/')) { routeEndpoint = '/' + routeEndpoint; }
    if (!routeEndpoint.endsWith('/')) { routeEndpoint += '/'; }
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.get<ServiceResult>(this.runtimeConfig.dataBackend + routeEndpoint + id, { headers: headers });
  }

  /**
   * Update eines bestehenden Datensatzes
   * @param routeEndpoint Endpunkt für den Post-Request (z.b. '/users')
   * @param body der Datenbody vom entsprechenden generischen Typ, z.B. UserUpdateDto
   */
  update(routeEndpoint: string, body: UPDATE): Observable<ServiceResult> {
    if (!routeEndpoint.startsWith('/')) { routeEndpoint = '/' + routeEndpoint; }
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.put<ServiceResult>(this.runtimeConfig.dataBackend + routeEndpoint, body, { headers: headers });
  }

  /**
   * Löschen eines spezifischen Datensatzes über die id als Routenparameter
   * @param routeEndpoint Endpunkt für den GET-Request (z.b. '/users')
   * @param id id (UUID) des Datensatzes
   */
  deleteById(routeEndpoint: string, id: string): Observable<ServiceResult> {
    if (!routeEndpoint.startsWith('/')) { routeEndpoint = '/' + routeEndpoint; }
    if (!routeEndpoint.endsWith('/')) { routeEndpoint += '/'; }
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.delete<ServiceResult>(this.runtimeConfig.dataBackend + routeEndpoint + id, { headers: headers });
  }

}
